import classNames from 'classnames';
import { forwardRef } from 'react';
import { RECAP_ACCESS_LEVELS } from 'features/recaps/constants';
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context';
import { AccessLevelForm } from './access_level_form';
import { AccessList } from './access_list';
import { AccessListScroll } from './access_list/access_list_scroll';
import { RecipientsPicker } from './recipients_picker';
const contentCss = "ch72s7g";
const fixedSectionCss = "f1dv1bvf";
const FixedSection = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(fixedSectionCss, props.className)} />;
});
const ContentContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(contentCss, props.className)} />;
});
export const Content = () => {
  const {
    accessLevel: {
      value: accessLevel
    }
  } = useRecapShare();
  const showSearch = accessLevel === RECAP_ACCESS_LEVELS.RESTRICTED;
  return <ContentContainer>
      <FixedSection>
        <AccessLevelForm />
      </FixedSection>
      <FixedSection>
        <RecipientsPicker showSearch={showSearch} />
      </FixedSection>
      <AccessListScroll>
        <AccessList />
      </AccessListScroll>
    </ContentContainer>;
};

require("./content.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./content.js");